var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransfer = function SvgTransfer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    stroke: "#447EFF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2643 9.92375C18.2643 11.6618 16.821 13.0975 15.0072 13.0975C13.1934 13.0975 11.7501 11.6618 11.7501 9.92375C11.7501 8.18573 13.1934 6.75 15.0072 6.75C16.821 6.75 18.2643 8.18573 18.2643 9.92375Z",
    stroke: "#447EFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1107 21.368H8.5C7.94771 21.368 7.49254 20.9175 7.57238 20.371C8.10158 16.7491 11.4562 13.9562 15.1107 13.9562C16.3722 13.9562 17.5581 14.289 18.5897 14.8738",
    stroke: "#447EFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3585 15.7562C21.1746 15.5501 20.8585 15.5322 20.6525 15.716C20.4465 15.8999 20.4285 16.216 20.6124 16.422L21.2408 17.1262H17.1139C16.8377 17.1262 16.6139 17.35 16.6139 17.6262C16.6139 17.9023 16.8377 18.1262 17.1139 18.1262H22.3571C22.5542 18.1262 22.7329 18.0104 22.8135 17.8305C22.894 17.6507 22.8614 17.4403 22.7302 17.2932L21.3585 15.7562ZM18.1121 21.6556C18.296 21.8616 18.6121 21.8796 18.8181 21.6957C19.0241 21.5118 19.0421 21.1958 18.8582 20.9897L18.2298 20.2856H22.3568C22.6329 20.2856 22.8568 20.0617 22.8568 19.7856C22.8568 19.5094 22.6329 19.2856 22.3568 19.2856H17.1135C16.9164 19.2856 16.7377 19.4014 16.6572 19.5812C16.5766 19.7611 16.6092 19.9715 16.7404 20.1185L18.1121 21.6556Z",
    fill: "#447EFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransfer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transfer.bfcb94a0.svg";